import { APIBase } from '../api-base'

export class IdentityPagesAPI extends APIBase {
    /**
     * Verify passwordless login token
     *
     * @param data
     */
    public static async verifyPasswordlessLogin(data: Record<string, string>) {
        const csrfTokenInputElement = document.querySelector('[name=csrfmiddlewaretoken]') as HTMLInputElement
        const csrfToken = (csrfTokenInputElement) ? csrfTokenInputElement.value : ''
        const url = '/api-root/subscription/identity/verify_passwordless_login/'

        return IdentityPagesAPI.postData(url, data, csrfToken)
    }

    /**
     * Get Newspapers.com third party authentication URL
     *
     * @param accessToken string
     */
    public static async getNewspapersTpaUrl(accessToken: string) {
        const csrfTokenInputElement = document.querySelector('[name=csrfmiddlewaretoken]') as HTMLInputElement
        const csrfToken = (csrfTokenInputElement) ? csrfTokenInputElement.value : ''
        const url = '/api-root/newspaper_archive/redirect/'
        const data = {}

        return IdentityPagesAPI.postData(url, data, csrfToken, accessToken)
    }
}
